// Lädt ALLE Bilder aus src/assets/services und Unterordnern
const context = require.context(
  "../assets/services",
  true,
  /\.(png|jpe?g|webp)$/i
);

export function getServiceImages(folder) {
  const images = context
    .keys()
    .filter((path) => path.includes(`/${folder}/`))
    .sort((a, b) => b.localeCompare(a)) // 🔥 Neueste zuerst nach Dateiname
    .map(context);

  return images;
}
